import React, { Component } from 'react';

import { Button, Box, Text, Modal } from 'components';

import api from 'api';
import AddressList from './AddressList';

class Addresses extends Component {
  state = {
    wallet_addresses: []
  };

  componentDidMount() {
    api.get('wallet_addresses').then(res => {
      this.setState({ wallet_addresses: res.data.items });
    });
  }

  addAddress = address => {
    const { wallet_addresses } = this.state;
    this.setState({
      wallet_addresses: [address, ...wallet_addresses],
    });
  };

  render() {
    const { wallet_addresses } = this.state;

    if (!wallet_addresses) return null;

    return (
      <Box
        className="ml-md"
        style={{ position: 'relative', maxHeight: 280, overflow: 'hidden' }}
        shadow
        mb="4"
        flex="1"
        p="4"
      >
        <Box flex>
          <Text display="h4">My Address</Text>
        </Box>
        {wallet_addresses.length > 0 && (
          <Box py="3">
            <AddressList data={wallet_addresses} />
          </Box>
        )}
        {wallet_addresses.length === 0 && (
          <Box py="3">No wallet addresses yet.</Box>
        )}
        {wallet_addresses.length > 3 && (
          <Box className="show-more">
            <Modal close={false} action={<div>Show More</div>}>
              {({ onClose }) => (
                <Box>
                  <AddressList scroll data={wallet_addresses} />
                  <Box pt="3">
                    <Button secondary fill onClick={onClose}>
                      Close
                    </Button>
                  </Box>
                </Box>
              )}
            </Modal>
          </Box>
        )}
      </Box>
    );
  }
}

export default Addresses;
